module.exports = __webpack_public_path__ + "img/violet_112.3d1f3064.png";